<template>
<div class="page_acount page">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="info">
            <div class="info_t">
                <div class="info_t_item">
                    <div class="item_title">商城收入</div>
                    <div class="item_cash">{{ info.shop_money ? info.shop_money : 0}}</div>
                </div>
                <div class="line"></div>
                <div class="info_t_item">
                    <div class="item_title">云收入</div>
                    <div class="item_cash">{{ info.underline_money ? info.underline_money : 0}}</div>
                </div>
            </div>
            <div class="info_action" @click="goWithdraw('/agent/withdraw')">提现</div>
        </div>
    </div>
    <!--  -->
    <div class="con">
        <!-- 平台服务 -->
        <ul class="list_con">
            <li class="item" @click="goPage('agent-withdrawList')">
                <span class="item_title">提现明细</span>
                <img :src="publicPath+'statics/images/icon_center_right.png'" alt="" class="icon_right">
            </li>
            <li class="item" @click="goPage('bank-index')">
                <span class="item_title">银行卡管理</span>
                <img :src="publicPath+'statics/images/icon_center_right.png'" alt="" class="icon_right">
            </li>
            <li class="item" @click="goPage('tradesman-income')">
                <span class="item_title">收入明细</span>
                <img :src="publicPath+'statics/images/icon_center_right.png'" alt="" class="icon_right">
            </li>
        </ul>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            tradesmanList: [], //商户列表
            partner: {},
            canAddTradesmanList: [], //可添加商户列表
			token: null,
			tradesman_id: this.$route.query.tradesman_id
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "账户中心"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function () {

    },
    methods: {
        getData() {
            var param = {
				token: this.token,
				tradesman_id: this.tradesman_id
            }
            this.$api.tradesman.info(param).then(res => {
                if (res.code == 200) {
                    this.info = res.result;
					console.log("info",this.info.un_receive_money)
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
		},
		// 提现
		goWithdraw(path) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var url = this.$publicData.clientUrl + path + '?price='+(this.info.shop_money?this.info.shop_money:'0')+'&type=1'
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: path,
                    query: {
                        price: this.info.shop_money,
                        type: 1 // 1 商城订单提现 2云订单提现 3城市合伙人提现 4代理商户提现 5用户提现
                    }
                })
            }
			
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
